import React, { useEffect, useState } from 'react';
import Fetch from '../../../functions/Fetch';
import config from '../../../../../../config/config';
import '../ReportStyle.css';
import moment from 'moment';
import * as XLSX from 'xlsx'
import ExportButtons from '../ExportButtons';
import { formatCurrency } from '../../../../../../helpers/pcontas';

const ExpenseReportV2 = (props) => {
    const [items, setItems] = useState([]);

    const startDate = moment(props.filters.startDate).format('DD/MM/YYYY');
    const endDate = moment(props.filters.endDate).format('DD/MM/YYYY');

    useEffect(() => {
        const fetchData = async () => {
            const response = await Fetch.post(config.endpoints.backend + 'portal/getreport', props.filters);
            setItems(response);
        }

        fetchData();
    }, [props.filters])

    function dataForSheet(){
        let sheets = {};

        const expenseReportV2Table = document.getElementById('expenseReportV2');
        const expenseReportV2Data = XLSX.utils.sheet_to_json((XLSX.utils.table_to_sheet(expenseReportV2Table, {raw: true})), {raw: true, header: 1});

        sheets.expenseReportV2Data = expenseReportV2Data;
        
        return sheets;
    }

    function dataForCsv() {
        const tableExpenseReportV2 = document.getElementById('expenseReportV2');
    
        const dataTableExpenseReportV2 = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(tableExpenseReportV2, {raw: true}), { header: 1, raw: true});

        return dataTableExpenseReportV2
    }
    
    function dataForJson(){
        let expenseReportv2 = [];

        if(!!items.reports.report){
            items.reports.report.forEach(item => {
                let currentObject = {};
                for (const key of items.reports.headers) {
                    currentObject[key] = item[key];
                }

                expenseReportv2.push(currentObject)
            })
        }

        return {
            expenseReportv2
        };
    }

    return (
        <div>
        {items.reports && (
                <div className='containerDird'>   
                    <div className='row info-filters'>
                        <div className='col-12'>
                            <p>Projeto: <b>{items.reports.pdcProject.project_name}</b></p>
                        </div>
                        <div className='col-12'>
                            <p>Origem dos Recursos: <b>{items.reports.originResourceName}</b></p>
                        </div>
                        <div className='col-12'>
                            <p>Período Selecionado: <b>{startDate} até {endDate}</b></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <ExportButtons 
                            jsonData={dataForJson} 
                            csvData={dataForCsv} 
                            sheetData={dataForSheet} 
                            pdfAttributes={{
                                    ids: ['expenseReportV2'], 
                                    optionsPdf: {format: 'a3', orientation: 'landscape'},
                                    styles:{
                                        expenseReportV2:{
                                            columnStyles: {
                                                0: { cellWidth: 25 },
                                                1: { cellWidth: 25 },
                                                2: { cellWidth: 25 },
                                                12: { cellWidth: 30}
                                            }
                                        }
                                    }
                                }
                            }
                            txtAttributes={{
                                expenseReportV2: {
                                    colSizes: [40,40,40,80,40,40,80,80,40,40,40,80,40]
                                },
                            }}
                    />
                    </div>
                    <div class="row">
                        <table className="table tables-report" id='expenseReportV2' margin="2" cellspacing="0" cellpadding="5">
                            <thead className='text-center '>
                                <tr>
                                    {items.reports.headers.map(header => (<th style={{maxWidth: '200px'}} className=''>{header}</th>))}
                                </tr>
                            </thead>
                            <tbody className='tbody-expensev2'>
                                {items.reports.report.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                    {Object.keys(row).map((item) => {
                                       let currentValue = items.reports.report[rowIndex][item];
                                       let className = 'text-right';
                                       let styleTd = '';
                                       if(item === 'Descrição do Produto / Serviço' || item.includes('CPF') || item.includes('CNPJ')){
                                            className = 'text-left';
                                            styleTd = {width: '100rem'};
                                        }else if(item === 'Valor Pago'){
                                            currentValue = formatCurrency(currentValue);
                                        }
                                        else{
                                            className = 'text-center';
                                        }
                                       return <td className={className} style={{...styleTd}}>{currentValue}</td>
                                    })}
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan={12}>Total</td>
                                    <td className='tdValue' colSpan={1}>{formatCurrency(items.reports.totalSum.toFixed(2))}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};
    
export default ExpenseReportV2;
    